import { FormDuufFieldData } from './FormDuuf'

const defaultValues = (fields: any) => {
  const form: any = {}

  fields.forEach((field: FormDuufFieldData) => {
    form[`input_${field.id}`] = ''
  })

  return form
}

export default defaultValues
